<template>
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 0C6.12749 0 5.2932 0.175549 4.5332 0.488281L3.14453 1.05859L7.08594 5L5.5 6.58594L1.55859 2.64453L0.988281 4.0332C0.675548 4.7932 0.5 5.62749 0.5 6.5C0.5 10.0783 3.42173 13 7 13C7.61867 13 8.18096 12.8166 8.74805 12.6543L17.6562 21.5605C18.2344 22.1387 19.1992 22.1387 19.7773 21.5605L22.0625 19.2734C22.6365 18.6965 22.6376 17.7313 22.0605 17.1543L13.1543 8.24805C13.3164 7.681 13.5 7.11865 13.5 6.5C13.5 2.92173 10.5783 0 7 0ZM7 2C9.49773 2 11.5 4.00227 11.5 6.5C11.5 7.10695 11.378 7.68181 11.1602 8.21289L10.9082 8.83008L20.293 18.2148L18.7168 19.793L9.33008 10.4062L8.71289 10.6602C8.18251 10.8785 7.60813 11 7 11C4.50227 11 2.5 8.99773 2.5 6.5C2.5 6.47441 2.51324 6.45321 2.51367 6.42773L5.5 9.41406L9.91406 5L6.92773 2.01367C6.95321 2.01324 6.97441 2 7 2Z"
      fill="#939393"
    />
  </svg>
</template>

<script>
/**
 * @fileoverview Tools Icon
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

export default {
  name: "ToolsIcon",
};
</script>

<style lang="scss" scoped>
</style>